import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {ConversationInquiryModel} from '../../../../../../libs/shared/core/src/models/api/conversationInquiriesModel';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {TooltipCoordinator} from '../../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';

interface InquiryStatusIconProps {
  className?: string;
  inquiry: ConversationInquiryModel;
}

export const InquiryStatusIcon: FC<InquiryStatusIconProps> = ({className, inquiry}) => {
  const theme = useUserTheme();
  const {isResolved} = inquiry;

  return isResolved ? (
    <TooltipCoordinator render={() => <Trans id="synopsis-inquiry-resolved">Completed request</Trans>}>
      <Icon className={className} name="checkmarkCircleSmall" color={theme.palette.green.shade40} />
    </TooltipCoordinator>
  ) : (
    <TooltipCoordinator render={() => <Trans id="synopsis-inquiry-ongoing">Ongoing request</Trans>}>
      <Icon className={className} name="ongoingRequestSmall" color={theme.palette.orange.shade40} />
    </TooltipCoordinator>
  );
};
